





































import { Vue, Component, Prop } from 'vue-property-decorator'
import StudentHomeApi from '@/apis/ktpStudentHome/index';
import { MyVipCardValid } from '@/interfaces/vuexStateInterface';
import moment from 'moment';
import { TrackLogType } from '@/interfaces/paycoursetracklog';
  
//首页的课程分类的列表
@Component({
  name: 'payBigCourseLists',
  components: {

  },
  props: {

  }
})
export default class payBigCourseLists extends Vue {
    @Prop(({ default: '54px' }))  paddingTop!: string;

    moment=moment;
    private currentTime:number = Date.now()/1000;
    private courseList: Array<any> = [];

    created() {
        this.getHomeCourseList();
    }

    mounted(){
        this.currentTime = Date.now()/1000;
    }  

    getHomeCourseList() {
        StudentHomeApi.getHomeCourseList({ source: '1' }).then((res: any) => {
        this.courseList = res
        });
    }

    gotoCourseList(pid: string, id?: string) {
        let query: any = {};
        if (id) {
        query = { pid: pid, id: id };
        } else {
        query = { pid: pid };
        }
        this.$router.push({
        path: '/classification',
        query: query,
        });
    }

    //进入某个课程
    gotoCourse(courseData:any,item:any){
        StudentHomeApi.trackLog({
        type: TrackLogType.COUORSE,
        event_id: courseData.id,
        residence_time:(Date.now()/1000 - this.currentTime),
        });
        this.$router.push({ path: '/courseInfo', query: { courseid: courseData.id, categoryid:item.child[0].id} })
    }

}
